import React from 'react';
import PropTypes from 'prop-types';
import { Modal, Button } from 'react-bootstrap';

// Confirm before removing a not-yet-sent video chip — unlike file chips, a video is an upload
// the user may have spent minutes recording, so a stray trash tap shouldn't discard it silently.
function ConfirmVideoDeleteModal({
 show, recorded = false, onCancel, onConfirm, modalClassName = null,
}) {
  return (
    <Modal show={show} onHide={onCancel} centered className={modalClassName}>
      <Modal.Header closeButton className="border-0">
        <Modal.Title style={{ fontSize: '18px' }}>Delete Video</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Are you sure you want to delete your {recorded ? 'recorded video' : 'video'}?
      </Modal.Body>
      <Modal.Footer className="border-0">
        <Button variant="outline-secondary" onClick={onCancel}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onConfirm}>
          Yes, delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

ConfirmVideoDeleteModal.propTypes = {
  show: PropTypes.bool.isRequired,
  recorded: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  modalClassName: PropTypes.string,
};

export default ConfirmVideoDeleteModal;
